var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-box',{class:['spinner'],style:(("border-width: " + _vm.width + "px; animation-duration: " + _vm.animationSpeed + "ms")),attrs:{"w":_vm.theSize,"h":_vm.theSize,"border-t":_vm.color,"border-l":_vm.color}})}
var staticRenderFns = []

export { render, staticRenderFns }